import { OriginInfo } from "@/types";
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

export type TrainStationCountryCode = "UK" | "FR" | "NL" | "BE"

export const trainStationsByCountry: Record<TrainStationCountryCode, Array<[string, OriginInfo]>> = {
	UK: [
		["STP", { name: "London Saint Pancras" }]
	],
	FR: [
		["PLY", { name: "Paris - Gare de Lyon" }]
	],
	NL: [
		["AMS", { name: "Amsterdam Centraal" }],
		["RTM", { name: "Rotterdam Centraal" }],
	],
	BE: [
		["ANR", { name: "Antwerp" }],
		["BRU", { name: "Brussels" }],
	],
}

export const trainStationCodeMapByWebsiteDomain: Record<string, Map<string, OriginInfo>> = {
	"www.uk.travelski.com": new Map<string, OriginInfo>(trainStationsByCountry.UK),
	"www.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.FR, ...trainStationsByCountry.BE]),
	"www.nl.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.NL, ...trainStationsByCountry.BE]),
}
const country = getSiteFromDomain(window.location.hostname);
export const trainStationCodeMap = new Map<string, OriginInfo>(trainStationCodeMapByWebsiteDomain[country]);

// export const trainStationCodeMap = new Map<string, OriginInfo>(Object.values(trainStationsByCountry).flat())
